module.exports = __webpack_public_path__ + "mo/img/swiper_bg01.3c3166e7.png";